/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FolderPlusIcon24Solid = forwardRef('FolderPlusIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 5a2 2 0 0 1 2-2h4.868a2 2 0 0 1 1.715.971l.399.665a.75.75 0 0 0 .643.364H18a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V5Zm11 4.69a1 1 0 1 0-2 0V12H8.69a1 1 0 0 0 0 2H11v2.31a1 1 0 0 0 2 0V14h2.31a1 1 0 1 0 0-2H13V9.69Z" })));
});
